import React from "react";
import { AskBuddyProvider } from "./context/AskBuddyContext";
import { TutorRecommendationsProvider } from "./context/TutorRecommendationsContext";
import { LearningFromWebWithAiProvider } from "./context/LearningFromWebWithAiContext";
import { AIConsumptionProvider } from "./context/AIConsumptionContext";
import { TrustedNetworkContext } from "./context/TrustedNetworkContext";
import NotificationProvider from "./context/NotificationContext";
import { IntelligentGradingContext } from "./pages/Assignment/context/useIntelligentGrading";
import {
  AssignmentContext,
  AssignmentProvider,
} from "./context/AssignmentContext";
import { MagicBarProvider } from "./context/MagicBarContext";

export const GlobalContextProvider = (props) => {
  return (
    <NotificationProvider user={props.user}>
      <AskBuddyProvider user={props.user} setUser={props.setUser}>
        <LearningFromWebWithAiProvider
          user={props.user}
          setUser={props.setUser}
        >
          <TutorRecommendationsProvider user={props.user}>
            <AIConsumptionProvider user={props.user}>
              <TrustedNetworkContext user={props.user}>
                {/* <AssignmentContext> */}
                <AssignmentProvider>
                  <IntelligentGradingContext user={props.user}>
                    <MagicBarProvider user={props.user} setUser={props.setUser}>
                      {props.children}
                    </MagicBarProvider>
                  </IntelligentGradingContext>
                </AssignmentProvider>
                {/* </AssignmentContext> */}
              </TrustedNetworkContext>
            </AIConsumptionProvider>
          </TutorRecommendationsProvider>
        </LearningFromWebWithAiProvider>
      </AskBuddyProvider>
    </NotificationProvider>
  );
};
